import { Component } from '@grafikr/components';

import { NonNullish } from 'utils/nullish-check';

// import { hide as hideOverlay, show as showOverlay } from 'utils/overlay';

export default Component((node) => {
  const trigger = NonNullish(node.parentElement);
  const header = NonNullish(document.querySelector<HTMLElement>('[data-component="header"]'));

  const HEADER_ACTIVE_CLASS = 'bg-white';

  trigger.addEventListener('mouseenter', () => {
    header.classList.add(HEADER_ACTIVE_CLASS);
    // showOverlay();
  });

  trigger.addEventListener('mouseleave', () => {
    header.classList.remove(HEADER_ACTIVE_CLASS);
    // hideOverlay();
  });
});
